import { ContactDialogComponent, ContactDialogData } from '@/components/contact-dialog/contact-dialog.component';
import {
  PropertyServicesDialogComponent,
  PropertyServicesDialogData
} from '@/components/property-services-dialog/property-services-dialog.component';
import { ObjectUpdatedType } from '@/enums/ObjectUpdatedType.enum';
import { UserHelper } from '@/helpers/user.helper';
import { AppConfigService } from '@/services/app-config.service';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MarketPlaceService, PropertyCompanyService, RealProperty } from '@eemo/api-client';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CommaStringArrayPipe } from '../../../extensions/commaStringArrayPipe';
import { PropertyCustomServicesComponent } from '../../../components/property-custom-services/property-custom-services.component';
import { MatButtonModule } from '@angular/material/button';
import { ImgDisplayComponent } from '../../../components/img-display/img-display.component';
import { ReferentComponent } from '../../../components/referent/referent.component';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export interface Contact {
  name: string;
  category: string;
  description: string;
  phone: string;
  email: string;
  city: string;
}

@Component({
    selector: 'app-property-services',
    templateUrl: './property-services.component.html',
    styleUrls: ['./property-services.component.scss'],
    standalone: true,
    imports: [MatIconModule, NgIf, ReferentComponent, MatTableModule, MatSortModule, ImgDisplayComponent, MatButtonModule, PropertyCustomServicesComponent, CommaStringArrayPipe]
})
export class PropertyServicesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @Input() prop: RealProperty;

  dataSource: MatTableDataSource<PropertyCompanyService>;
  displayFullColumns = false;
  tableClass = 'light';
  displayedColumns = ['logo', 'companyName', 'companySummary', 'companyCity', 'companyServices', 'contact'];
  getServicesSub = new Subscription();
  objectUpdateSub = new Subscription();
  canManageServices = false;

  constructor(
    private dialog: MatDialog,
    private marketPlaceService: MarketPlaceService,
    private appConfigService: AppConfigService,
    private translate: TranslateService,
    private userHelper: UserHelper
  ) {
    this.prop = this.appConfigService.selectedProp;
  }

  ngOnInit() {
    this.canManageServices = this.userHelper.canManagePropertyService(this.prop);
    this.loadData();
    this.objectUpdateSub = this.appConfigService.objectUpdated.subscribe((type) => {
      if (type === ObjectUpdatedType.SERVICE) {
        this.loadData();
      }
    });
  }

  ngOnDestroy(): void {
    this.getServicesSub.unsubscribe();
    this.objectUpdateSub.unsubscribe();
  }

  loadData() {
    let filter: string;
    if (this.dataSource && this.dataSource.filter) {
      filter = this.dataSource.filter;
    }
    // TODO manage pagination
    this.getServicesSub = this.marketPlaceService.getPropertyCompanyServices(this.prop.uid).subscribe((data) => {
      const displayedData = [];
      data.forEach((i) => {
        const row = {
          service: i,
          companyName: i.name,
          companyId: i.uid,
          companySummary: i.summary,
          companyCity: i.city,
          companyServices: i.services.map((s) => this.translate.instant('enum.ServiceType.' + s))
        };
        displayedData.push(row);
      });
      this.dataSource = new MatTableDataSource(displayedData);
      // *ngIf break the sort : must be set in background
      setTimeout(() => (this.dataSource.sort = this.sort));
      this.dataSource.sort = this.sort;
      if (filter) {
        this.applyFilter(filter);
      }
    });
  }

  ngAfterViewInit() {}

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  doContact(name: string, companyId: string) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const data: ContactDialogData = {
        type: 'propertyService',
        prop: this.prop,
        targetName: name,
        targetEmail: companyId
      };
      const dialogRef = this.dialog.open(ContactDialogComponent, {
        // width: '20rem'
        data
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.loadData();
        }
      });
    }
  }

  manageServices() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const data: PropertyServicesDialogData = { property: this.prop };
      const dialogRef = this.dialog.open(PropertyServicesDialogComponent, {
        data
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.loadData();
        this.appConfigService.triggerObjectUpdated(ObjectUpdatedType.SERVICE);
      });
    }
  }
}
